import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createSafeNotification } from './utils/security';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA update notification
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Show update notification using secure method
    const updateBanner = createSafeNotification({
      title: 'Nova versão disponível!',
      message: 'A aplicação foi atualizada. Recarregue para usar a versão mais recente.',
      type: 'info',
      confirmText: 'Recarregar',
      dismissText: 'Mais tarde',
      onConfirm: () => window.location.reload()
    });
    
    document.body.appendChild(updateBanner);
  });
}